"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "favignana": {
    "isola-di-formica": [{
      "hkey": "f27c06a7",
      "slug": "favignana",
      "name": "Favignana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "isola-del-maraone": [{
      "hkey": "f27c06a7",
      "slug": "favignana",
      "name": "Favignana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c00f0c9d": [{
      "hkey": "f27c06a7",
      "slug": "favignana",
      "name": "Favignana",
      "primary": true,
      "skipSearch": false
    }],
    "9b1b48fa": [{
      "hkey": "82dd1197",
      "slug": "isola-di-favignana",
      "name": "Isola di Favignana",
      "primary": true,
      "skipSearch": false
    }],
    "arcipelago-delle-isole-egadi-isola-di-favignana": [{
      "hkey": "82dd1197",
      "slug": "isola-di-favignana",
      "name": "Isola di Favignana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0e3e9592": [{
      "hkey": "f27c06a7",
      "slug": "favignana",
      "name": "Favignana",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;